import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class InvoicedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            isLoading: false,
            getInvoicedReportUrl: '/api/v1/portal/portal-admin/invoiced-jobs-report',
            InvoicedJobsReportData: [],
            downloadReportName: 'Invoiced Jobs Report',
            selectedCustomers: [],
            customers: [],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }

    componentDidMount() {
        let options = [];
        return fetch(this.state.url, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + (window.api_token || ''),
                "Accept": 'application/json'
            },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                if (Array.isArray(response)) {
                    response.map((customer) => {
                        if (customer && customer.company && customer.company.short_name && customer.name && customer.id) {
                            options.push({
                                label: (customer.company.short_name || '') + '-' + (customer.name || ''),
                                value: customer.id || ''
                            });
                        }
                    });
                }
                this.setState({
                    customers: options,
                    isLoading: false
                });
            }).catch(() => { });
        }).catch(() => { });
    }

    handleStartDateChange(date) {
        this.setState({ startDate: date || this.state.startDate });
    }

    handleEndDateChange(date) {
        this.setState({ endDate: date || this.state.endDate });
    }

    handleCustomerSelection(selectedCustomers) {
        this.setState({ selectedCustomers: selectedCustomers || [] });
    }

    handleInvoicedJobsReportGeneration(e) {
        this.setState({ isLoading: true });
        let url = this.state.getInvoicedReportUrl || '';
        if (!url) return;

        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + (window.api_token || ''),
                "Accept": 'application/json'
            },
            body: JSON.stringify({
                customer_ids: this.state.selectedCustomers || [],
                start_date: moment(this.state.startDate || new Date()).format("YYYY-MM-DD"),
                end_date: moment(this.state.endDate || new Date()).format("YYYY-MM-DD")
            }),
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
                this.setState({
                    InvoicedJobsReportData: Array.isArray(response) ? response : [],
                    isLoading: false
                });
            }).catch(() => {
                this.setState({ isLoading: false });
            });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    }

    download(filename, text) {
        filename = (filename || '') +
            ' From ' + moment(this.state.startDate || new Date()).format("YYYY-MM-DD") +
            ' To ' + moment(this.state.endDate || new Date()).format("YYYY-MM-DD") + '.xlsx';

        let url = "/api/v1/portal/finance/invoiced-job-report";
        return fetch(url, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Authorization": 'Bearer ' + (window.api_token || ''),
                "Accept": 'application/json',
            },
            body: JSON.stringify({
                customer_ids: this.state.selectedCustomers || [],
                start_date: moment(this.state.startDate || new Date()).format("YYYY-MM-DD"),
                end_date: moment(this.state.endDate || new Date()).format("YYYY-MM-DD")
            }),
        }).then(response => response.blob())
            .then(blob => {
                if (!blob) return;
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                a.remove();
            }).catch(() => {
                alert('sorry something went wrong.');
            });
    }

    render() {
        let invoicedJobs = [];
        const { selectedCustomers } = this.state;
        let downloadableCsvDataInvoiced = "Job Ref,Reg/VIN,Customer,From Address,To Address,Job price,Invoice Date,Invoice Number\n";

        if (Array.isArray(this.state.InvoicedJobsReportData) && this.state.InvoicedJobsReportData.length > 0) {
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                if (!currentJob) return;
                let joburl = "/jobs/view/" + (currentJob.id || '');
                let unitNumber = (currentJob.unit && currentJob.unit.unit_number) ? currentJob.unit.unit_number : "";
                let vinNumber = (currentJob.vehicle && currentJob.vehicle.vin_number) ? currentJob.vehicle.vin_number : "";
                let customerName = (currentJob.customer && currentJob.customer.name) ? currentJob.customer.name : "";
                let pickupAddress = (currentJob.pickup_address && currentJob.pickup_address.address_line_1) ? currentJob.pickup_address.address_line_1 : "";
                let dropoffAddress = (currentJob.dropoff_address && currentJob.dropoff_address.address_line_1) ? currentJob.dropoff_address.address_line_1 : "";
                let jobPrice = currentJob.job_price || "";
                let invoiceDate = (currentJob.invoice_date) ? moment(currentJob.invoice_date).format("DD.MM.YY") : "";
                let invoiceNumber = currentJob.invoice_number || "";

                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.id || ''}</a></td>
                        <td>{unitNumber || vinNumber}</td>
                        <td>{customerName}</td>
                        <td>{pickupAddress}</td>
                        <td>{dropoffAddress}</td>
                        <td>&pound;{jobPrice}</td>
                        <td>{invoiceDate}</td>
                        <td>{invoiceNumber}</td>
                    </tr>
                );

                downloadableCsvDataInvoiced +=
                    (currentJob.id || '') + ',' +
                    (unitNumber || '') + ',' +
                    (customerName || '') + ',' +
                    (pickupAddress || '') + ',' +
                    (dropoffAddress || '') + ',' +
                    (jobPrice || '') + ',' +
                    (invoiceDate || '') + ',' +
                    (invoiceNumber || '') + "\n";
            });
        } else {
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="8" className='text-center'>No Records</td></tr>
            );
        }

        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Invoiced Jobs Report</h2>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br />
                        <DatePicker
                            todayButton={"Today"}
                            dateFormat="dd/MM/yyyy"
                            onChange={this.handleStartDateChange}
                            selected={this.state.startDate || new Date()}
                        />
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br />
                        <DatePicker
                            todayButton={"Today"}
                            dateFormat="dd/MM/yyyy"
                            onChange={this.handleEndDateChange}
                            selected={this.state.endDate || new Date()}
                        />
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br />
                        <div>
                            <StatefulMultiSelect
                                options={Array.isArray(this.state.customers) ? this.state.customers : []}
                                selected={selectedCustomers || []}
                                onSelectedChanged={this.handleCustomerSelection}
                                overrideStrings={{
                                    selectSomeItems: "Select Customers...",
                                    allItemsAreSelected: "All Customers are Selected",
                                    selectAll: "Select All",
                                    search: "Search Customer",
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button
                                className="btn btn-lg btn-success invoiced-btn-margin"
                                onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}
                            >
                                <i className="fa fa-save"></i> Generate Invoiced Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button
                                className="btn btn-primary btn-lg invoiced-btn-margin"
                                onClick={(e) => {
                                    this.download(this.state.downloadReportName || '', downloadableCsvDataInvoiced || '');
                                }}
                            >
                                <i className="fa fa-download"></i> Download Invoiced Report
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <label className="alert alert-primary">
                            <b>{(Array.isArray(this.state.InvoicedJobsReportData) ? this.state.InvoicedJobsReportData.length : 0)} jobs found..</b>
                        </label>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>From Address</th>
                                        <th>To Address</th>
                                        <th>Job price</th>
                                        <th>Invoice Date</th>
                                        <th>Invoice Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ?
                                        (<tr><td colSpan="14"><span className="add-loading-text">
                                            <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                        invoicedJobs
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br /><br /><br />
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('react-component-g4-logistics-portal-invoiced_jobs_report')) {
    ReactDOM.render(
        <InvoicedJobsReport message_if_none='Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-invoiced_jobs_report')
    );
}